import { inject, Injectable } from '@angular/core';
import { ApiService } from '../utils/api/api-service';
import { getChatApi, safeApiCall } from '../utils/api/openapi-utils';
import { GetChatMessages200ResponseInner } from '../generated/api/aldebaran';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private api = inject(ApiService);

  //----------------------------
  //---LOAD CHAT MESSAGES ---
  //----------------------------

  public async loadChatMessages(params:{
    groupId: string, 
    chatId: string
  }): Promise<ChatMessages[]> {
    const chatApi = await getChatApi();
    
    const data = await safeApiCall('getMessages', () =>
      chatApi.getChatMessages({
        groupId: params.groupId,
        chatId: params.chatId,
        // fromTime: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), // Load messages from the last week
        // toTime: new Date()
      })
    );
     return Array.isArray(data) ? data : [];
  }

  public async sendChatMessage(params:{
    groupId: string, 
    chatId: string,
    content: string}
  ): Promise<boolean> {
    
    const chatApi = await getChatApi();
    const data = await safeApiCall('sendMessage', () =>
      chatApi.sendChatMessage({
        sendMessageRequest: {
          groupId: params.groupId,
          chatId: params.chatId,
          content: params.content,
          // fromTime: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), // Load messages from the last week
          // toTime: new Date()
        }
      })
    );
    return true;
    //return data?data.success:false;
  }
}

export type ChatMessages = GetChatMessages200ResponseInner;
